
import generateVersionHash from '@utils/generateVersionHash';
import axios from 'axios';
import { createListMutations, createListState } from '@utils/storeHelpers';
import api from './constants';
import { postApi } from '@/lib/fetcher';


const outletManagement = {
  namespaced: true,
  state() {
    return {
      ...createListState()(),
      errors: [],
      merchant: null,
      listMerchant: [],
      loadingListMerchant: false,
      requestListMerchant: null,
    };
  },
  mutations: {
    ...createListMutations(),

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setCancelationRLMerchant(state, payload) {
      state.requestListMerchant = payload;
    },

    setLoadingListMerchant(state, loading) {
      state.loadingListMerchant = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },

    setMerchantVariable(state, { variable, payload }) {
      state.merchant[variable] = payload;
    },

    setListMerchant(state, payload) {
      state.listMerchant = payload;
    },

    removeOutlet(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter(
        (value) => value.id !== index
      );
    },

    editOutlet(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },
  },
  actions: {
    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, search, merchantId }
    ) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const merchantIdVal = merchantId == null ? '' : merchantId;
      const sortBy = 'id ASC';

      const data = JSON.stringify({
        search,
        sort_by: sortBy,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: merchantIdVal.toString(),
        version: generateVersionHash(
          sortBy + itemsPerPage.toString() + page.toString(),
          date
        ),
      });

      const urlApi = api.GET_LIST_OUTLET_MANAGEMENT;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 200) {
        ctx.commit('setTotalData', {
          payload: responseData,
        });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async updateOutlet(ctx, { date, outlet, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: outlet.id.toString(),
        email: outlet.email,
        version: generateVersionHash('', date),
      });

      const urlApi = api.CHANGE_MERCHANT;

      const responseData = await postApi(ctx, urlApi, data);
      let resVal = false;

      if (responseData?.code === 200) {
        ctx.commit('removeOutlet', {
          index,
        });
        resVal = true;
      }
      return resVal;
    },

    async updateOutlettoOM(ctx, { date, outlet }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id_outlet: outlet.id_outlet.toString(),
        core_merchant: outlet.core_merchant,
        version: generateVersionHash('', date),
      });
      const urlApi = api.MOVE_MERCHANT;

      const responseData = await postApi(ctx, urlApi, data);
      let resVal = false;

      if (responseData?.code === 200) {
        resVal = true;
      }
      return resVal;
    },

    async getMerchant(ctx, { query, date }) {
      if (ctx.state.requestListMerchant) ctx.state.requestListMerchant.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationRLMerchant', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        search: {
          mid: query,
        },
        sort_by: 'id ASC',
        limit: '50',
        version: generateVersionHash('', date),
      });
      const urlApi = api.VIEW_MERCHANT;
      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code === 200) {
        ctx.commit('setListMerchant', responseData.data.list);
      }
    },
  },
};

export default outletManagement;
